const addMessage = {
  path: 'agentMessage/addMessage',
  component: resolve => require(['@/pages/admin/businessmag/agentMessage/addMessage'], resolve),
  meta: {
    requireAuth: true
  },
  children: [
  ]
}

export default addMessage